<template>
  <div
    class="modal fade"
    ref="modalEventInfo"
    id="eventInfoModal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="eventInfoModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title fs-5" id="eventInfoModalLabel">
            INFORMACIÓN DEL EVENTO
          </h5>
          <button
            class="btn-close"
            type="button"
            @click="hide()"
            aria-label="Close"
          ></button>
        </div>
        <div class="modal-body">
          <form>
            <div class="row mb-3">
              <div class="col-12 mb-3">
                <label for="eventTitle" class="form-label fw-bold"
                  >Título del Evento</label
                >
                <textarea
                  id="eventTitle"
                  type="text"
                  class="form-control disabled-check"
                  :value="eventData.title"
                  rows="3"
                  disabled
                />
              </div>
              <div class="col-12">
                <label for="eventDescription" class="form-label fw-bold"
                  >Descripción</label
                >
                <textarea
                  id="eventDescription"
                  class="form-control disabled-check"
                  :value="eventData.description"
                  rows="3"
                  disabled
                ></textarea>
              </div>
            </div>

            <div class="row mb-3">
              <div class="col-md-6 col-12 mb-2">
                <label for="dateInscriptionStart" class="form-label fw-bold"
                  >Inicio inscripción</label
                >
                <input
                  id="dateInscriptionStart"
                  type="text"
                  class="form-control disabled-check"
                  :value="formatDate(eventData.init_date_inscription)"
                  disabled
                />
              </div>
              <div class="col-md-6 col-12 mb-2">
                <label for="dateInscriptionEnd" class="form-label fw-bold"
                  >Fin inscripción</label
                >
                <input
                  id="dateInscriptionEnd"
                  type="text"
                  class="form-control disabled-check"
                  :value="formatDate(eventData.end_date_inscription)"
                  disabled
                />
              </div>
              <div class="col-md-6 col-12 mb-2">
                <label for="dateEventStart" class="form-label fw-bold"
                  >Inicio evento</label
                >
                <input
                  id="dateEventStart"
                  type="text"
                  class="form-control disabled-check"
                  :value="formatDate(eventData.init_date)"
                  disabled
                />
              </div>
              <div class="col-md-6 col-12 mb-2">
                <label for="dateEventEnd" class="form-label fw-bold"
                  >Fin evento</label
                >
                <input
                  id="dateEventEnd"
                  type="text"
                  class="form-control disabled-check"
                  :value="formatDate(eventData.end_date)"
                  disabled
                />
              </div>
            </div>

            <div
              class="row mb-3"
              v-if="schedules && Object.keys(schedules).length"
            >
              <div class="col-12">
                <label class="form-label fw-bold">Horarios del Evento</label>
                <div class="d-flex flex-wrap gap-2">
                  <div
                    v-for="(day, key) in schedules"
                    :key="key"
                    class="p-2 border rounded"
                    style="min-width: 120px"
                  >
                    <div class="fw-semibold text-primary text-center mb-1">
                      {{ formatDayLabel(key) }}
                    </div>
                    <ul class="list-unstyled mb-0">
                      <li
                        v-for="(schedule, i) in day.horarios"
                        :key="i"
                        class="text-center"
                      >
                        <i class="fa fa-clock-o me-1"></i
                        >{{ schedule.inicio }} -
                        {{ schedule.fin }}
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            <div class="row mb-3">
              <div
                class="col-md-6 col-12 mb-2"
                v-if="eventData.maximum != null"
              >
                <label for="eventCapacity" class="form-label fw-bold"
                  >Capacidad</label
                >
                <input
                  id="eventCapacity"
                  type="text"
                  class="form-control disabled-check"
                  :value="
                    eventData.minimum != null
                      ? `${eventData.minimum} / ${eventData.maximum}`
                      : `${eventData.maximum} (Máx.)`
                  "
                  disabled
                />
              </div>
              <div class="col-md-6 col-12 mb-2">
                <label for="eventModality" class="form-label fw-bold"
                  >Modalidad</label
                >
                <input
                  id="eventModality"
                  type="text"
                  class="form-control disabled-check"
                  :value="modality"
                  disabled
                />
              </div>
            </div>

            <div
              class="row mb-3"
              v-if="eventData.latitude && eventData.longitude"
            >
              <div class="col-12">
                <label for="eventLocation" class="form-label fw-bold"
                  >Ubicación</label
                >
                <div class="input-group">
                  <input
                    id="eventLocation"
                    type="text"
                    class="form-control disabled-check"
                    :value="eventData.place"
                    disabled
                  />
                  <button
                    class="btn btn-success"
                    type="button"
                    @click.prevent="openGoogleMaps"
                    title="Ver ubicación"
                  >
                    <i class="fa fa-map-marker"></i>
                  </button>
                </div>
              </div>
            </div>

            <div class="row mb-3">
              <div class="col-12">
                <label for="eventDetail" class="form-label fw-bold"
                  >Observación / Solicitud</label
                >
                <textarea
                  id="eventDetail"
                  class="form-control disabled-check"
                  :value="eventData.detail"
                  rows="3"
                  disabled
                ></textarea>
              </div>
            </div>

            <hr />
            <div class="row mb-3">
              <div class="col-12">
                <p class="fw-bold mb-2">Archivos Adjuntos:</p>
              </div>
              <div class="col-md-4 col-6">
                <div class="form-check form-check-display">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    :checked="hasPoster"
                    id="hasPoster"
                    disabled
                  />
                  <label class="form-check-label" for="hasPoster">
                    Tiene Afiche
                  </label>
                </div>
              </div>
              <div class="col-md-4 col-6">
                <div class="form-check form-check-display">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    :checked="hasBanner"
                    id="hasBanner"
                    disabled
                  />
                  <label class="form-check-label" for="hasBanner">
                    Tiene Banner
                  </label>
                </div>
              </div>
              <div class="col-md-4 col-6">
                <div class="form-check form-check-display">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    :checked="hasRegulation"
                    id="hasRegulation"
                    disabled
                  />
                  <label class="form-check-label" for="hasBanner">
                    Tiene Convocatoria
                  </label>
                </div>
              </div>
            </div>

            <hr />
            <div class="row mb-3">
              <div class="col-12">
                <p class="fw-bold mb-2">Requerimientos UNICOM:</p>
              </div>
              <div
                class="col-md-4 col-12"
                v-for="req in unicomRequirements"
                :key="req.label"
              >
                <div class="form-check form-check-display">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    :checked="req.value"
                    :id="`req_${req.label.replace(/\s/g, '')}`"
                    disabled
                  />
                  <label
                    class="form-check-label"
                    :for="`req_${req.label.replace(/\s/g, '')}`"
                  >
                    {{ req.label }}
                  </label>
                </div>
              </div>
            </div>
          </form>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" @click="hide()">
            Cerrar
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted } from "vue";
import { Modal } from "bootstrap";

const props = defineProps({
  event: { type: Object, default: () => ({}) },
});

const modalEventInfo = ref(null);
const eventInfoModal = ref(null);

const eventData = computed(() => props.event || {});

const modality = computed(() => {
  switch (eventData.value.modality) {
    case "PRESENCIAL":
      return "Presencial";
    case "VIRTUAL":
      return "Virtual";
    case "PRESENCIAL-VIRTUAL":
      return "Presencial-Virtual";
    default:
      return "Presencial";
  }
});

const hasPoster = computed(() => !!eventData.value.poster);
const hasBanner = computed(() => !!eventData.value.banner);
const hasRegulation = computed(() => !!eventData.value.regulation);

const unicomRequirements = computed(() => [
  { label: "Requiere Afiche", value: eventData.value.require_poster },
  { label: "Requiere Banner", value: eventData.value.require_banner },
  { label: "Requiere Foto/Video", value: eventData.value.require_photo_video },
  {
    label: "Requiere Redes Sociales",
    value: eventData.value.require_social_media,
  },
  { label: "Requiere Prensa", value: eventData.value.require_prensa },
  { label: "Es Webinnar", value: eventData.value.is_webinnar },
  { label: "Requiere transmisión en vivo", value: eventData.value.require_live_stream },
]);

const formatDate = (dateString) => {
  if (!dateString) return "";
  const date = new Date(dateString);
  return date.toLocaleDateString("es-ES", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  });
};

const show = () => {
  eventInfoModal.value.show();
};

const hide = () => {
  eventInfoModal.value.hide();
};

const openGoogleMaps = () => {
  if (eventData.value.latitude && eventData.value.longitude) {
    const url = `https://www.google.com/maps/search/?api=1&query=${eventData.value.latitude},${eventData.value.longitude}`;
    window.open(url, "_blank");
  }
};

const schedules = computed(() => {
  if (!eventData.value.schedules_json) return {};
  try {
    return JSON.parse(eventData.value.schedules_json);
  } catch (e) {
    console.error("Error parsing schedules_json:", e);
    return {};
  }
});

const formatDayLabel = (key) => {
  const match = key.match(/\d+/);
  return match ? `Día ${match[0]}` : key;
};

onMounted(() => {
  eventInfoModal.value = new Modal(modalEventInfo.value);
});

defineExpose({ show, hide });
</script>

<style scoped>
.disabled-check:disabled {
  background-color: var(--bs-body-bg, #fff);
  color: var(--bs-body-color, #212529);
  border-color: var(--bs-border-color, #dee2e6);
  opacity: 1;
  cursor: default;
}

.disabled-check:disabled:focus {
  box-shadow: none;
}

.form-check-display .form-check-input:disabled {
  opacity: 1;
  cursor: default;
  border-color: #0d6efd;
}

.form-check-display .form-check-input:checked:disabled {
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'%3e%3cpath fill='none' stroke='%23fff' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='m6 10 3 3 6-6'/%3e%3c/svg%3e");
}

.form-check-display .form-check-label {
  color: var(--bs-body-color, #000000);
  opacity: 1;
  cursor: default;
}
</style>
